import type { Page } from '@subaio/utils'

import { useRoutingContext } from './useRoutingContext'

const toRaw = (match: (url: string) => Page | null, func: (page: Page) => void) => (url: string) => {
	const page = match(url)
	if (!page) throw new Error(`Invalid URL ${url}`)

	func(page)
}

export const useNavigation = () => {
	const { push, replace, subscribe, getPath, back, match } = useRoutingContext()

	return {
		onNavigateTo: push,
		onUpdateUrlTo: replace,
		onNavigateBack: back,
		onNavigateRaw: toRaw(match, push),
		onUpdateUrlRaw: toRaw(match, replace),
		subscribeNavigation: subscribe,
		getPath,
	}
}
